import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { PaginatedResultModel } from '@data-layer/models/common';
import { ManagementDigitalSignModel, ManagementDigitalSignsSearchModel } from '@data-layer/models/management';

@Injectable({ providedIn: 'root' })
export class DigitalSignsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params: ManagementDigitalSignsSearchModel,
    isShowLoader: boolean = false,
  ): Observable<PaginatedResultModel<ManagementDigitalSignModel>> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/management/digital-signs`, { params }, { isShowLoader });
  }

  public cancel(id: number, isShowLoader: boolean = true): Observable<void> {
    return this.apiService.put<void>(`${environment.url.prefixCustoms}v2/management/digital-signs/${id}/cancel`, null, null, {
      isShowLoader,
    });
  }

  public resend(id: number, isShowLoader: boolean = true): Observable<void> {
    return this.apiService.post<void>(`${environment.url.prefixCustoms}v2/management/digital-signs/${id}/send`, null, null, {
      isShowLoader,
    });
  }

  public delete(id: number, isShowLoader: boolean = true): Observable<void> {
    return this.apiService.delete<void>(`${environment.url.prefixCustoms}v2/management/digital-signs/${id}`, null, {
      isShowLoader,
    });
  }
}
